document.addEventListener('DOMContentLoaded', function() {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   document.addEventListener("variant:changed", function(evt) {
	     // console.log( evt.currentVariant );
	     // document.querySelectorAll('[data-variant-toggle]').forEach(el => el.style.display = 'none');
	     // document.querySelector(`[data-variant-toggle="${evt.currentVariant.id}"]`)?.style.display = 'block';
	   });

});


// Additional Colour Variant Option JS
window.changeAdditionalVariants = function(){
  const all_additional_swatch_options = document.querySelectorAll('[data-additional-swatch-option]');
  if(all_additional_swatch_options.length > 0){
    all_additional_swatch_options.forEach(swatch_container=>{
      const additional_swatch_items = swatch_container.querySelectorAll('[data-additional-swatch-item]');
      if(additional_swatch_items.length > 0){
        additional_swatch_items.forEach(item=> item.addEventListener('click', ()=>{
          updateAdditionalSwatchOption(item, swatch_container);
        }));
      }
    })
  }
}

function updateAdditionalSwatchOption(currentItem, container){
  const selected_variant_id = currentItem?.getAttribute('additional-swatch-id');
  const _additional_swatch_items = container.querySelectorAll('[data-additional-swatch-item]');
  if(_additional_swatch_items.length > 0){
    _additional_swatch_items.forEach(item=> item.classList.remove('is--selected'));
  }
  currentItem.classList.add('is--selected');
  const currentItem_title = currentItem.getAttribute('data-additional-value');
  const title_container = container.querySelector('[data-additional-current-value]');
  if(currentItem_title != '' && currentItem_title != null && title_container){
    title_container.innerText = currentItem_title;
  }
}

document.addEventListener('DOMContentLoaded', window.changeAdditionalVariants);

if(document.querySelector('.information_icon')){
  document.querySelector('.information_icon').addEventListener('click', function () {
    const info = document.querySelector('.js-information-details');
    if (info.hasAttribute('hidden')) {
      info.removeAttribute('hidden');
    } else {
      info.setAttribute('hidden', true);
    }
  });  
}


